export const environment = {
    production: false,
    showDebug: false,
    apiUrl: 'https://testmyke.business.unc.edu/api',

    ssoUrl: "https://login.microsoftonline.com/ae2008a1-f68d-414a-a9ab-336bc8a857d2/oauth2/v2.0/authorize?client_id=9387d7f8-906a-4b70-8a30-9196e8eb4441&response_type=code&redirect_uri=https://testmyke.business.unc.edu/client/login/ocid&response_mode=query&scope=openid",
        

    alertPollingFrequency: 20000
};
// alertPollingFrequency is in Milliseconds
